import Button from '@/components/form/button'
import { LinkArticleDetail } from '@/components/links/article'
import { Article } from '@/entities/article'
import { formatDate } from '@utils'
import Image from 'next/image'

export default function InsightsDataViewCard({ data }: { data: Article }) {
  return (
    <LinkArticleDetail slug={data.slug} scroll={false} className='group'>
      <div
        className='relative overflow-hidden'
        style={{ aspectRatio: '380 / 240' }}
      >
        <Image
          src={data.coverSrc}
          alt={data.subject}
          width={380}
          height={240}
          unoptimized
          priority
          className='object-cover w-full h-full block transition-transform duration-500 group-hover:scale-110'
        />
        {data.videoUrl && (
          <div className='absolute inset-0 bg-black/40 grid place-items-center'>
            <Button className='w-15 h-15 rounded-full grid place-items-center'>
              <i className='w-0 h-0 block border-8 border-r-0 border-transparent border-l-white' />
            </Button>
          </div>
        )}
      </div>
      <div className='bg-bg-primary p-4 sm:p-6 sm:pt-5'>
        <h5 className='line-clamp-3 font-bold text-xl h-21'>{data.subject}</h5>
        <div className='text-font-primary/70 flex items-center justify-between mt-2.5'>
          <span>{data.authorName}</span>
          <time dateTime={formatDate(data.publishTime)}>
            {formatDate(data.publishTime, 'DD MMM YYYY')}
          </time>
        </div>
      </div>
    </LinkArticleDetail>
  )
}
